// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"styles_errorContainer__vwI2t","errorIcon":"styles_errorIcon__Sso6g","errorTitle":"styles_errorTitle__2Q9uT","errorText":"styles_errorText__znlbV","errorButton":"styles_errorButton__lqpu2"};
module.exports.__checksum = "55d808015f31"